module.exports = __webpack_public_path__ + "media/b_bppair_win.2183307e.mp3";